var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-start-1 col-span-6 flex justify-center"},[_c('ul',_vm._l((_vm.credits),function(ref,i){
var name = ref.name;
var responsibility = ref.responsibility;
return _c('li',{key:i,staticClass:"text-3-mob lg:text-3-desk"},[_c('span',{staticClass:"italic"},[_vm._v(_vm._s(responsibility)+": ")]),_c('span',{staticClass:"small-caps"},[_vm._v(_vm._s(name.toLowerCase()))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }